import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-341" data-mp="3fycofh2u5v85">
      <div className="mx-auto max-w-5xl" data-id="element-342" data-mp="3b0ud5k1cj3wz">
        <SectionHeading eyebrow="What professionals are saying" title={<>Practices that <em className="text-gold-dark" data-id="element-344" data-mp="3700rkxbdm179">built their system</em></>} data-id="element-343" data-mp="3b01hbe3xdytm" />

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-345" data-mp="32060asnov9lo">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 ring-1 ring-ink/10" data-id="element-346" data-mp="2x09xgwqq9o7p">
              <div className="flex items-center gap-4" data-id="element-347" data-mp="2s28ba2y098s0">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-348" data-mp="2s3ta44rcrdvo" />
                <div data-id="element-349" data-mp="q9tzzmpyv2kk">
                  <p className="text-[17px] font-extrabold text-ink" data-id="element-350" data-mp="qbeq9058zzcm">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-351" data-mp="h5os1hpjsial">{t.role}</p>
                </div>
              </div>
              <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-352" data-mp="m5b2xkhwlmg8">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-353" data-mp="79lhpokjldck" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[17px] leading-relaxed text-ink/80" data-id="element-354" data-mp="zwpq83iug9t3">“{t.quote}”</blockquote>
            </li>)}
        </ul>

        <SectionCta label="I want results like these" data-id="element-355" data-mp="14uzl0d0np8e6" />
      </div>
    </section>;
}